import {useState} from "react";
import _ from "lodash";
import {Box} from "@mui/system";
import {passwordStrength} from "check-password-strength";
import PasswordEntry from "./PasswordEntry";
import PasswordStrengthIndicator from "../../Onboarding/Signup/CompanySignup/PasswordStrengthIndicator";

export default function PasswordGroup({ input, name, meta, placeholder }) {
    const [value, setValue] = useState('');
    const [keyCount, setKeyCount] = useState(0);

    const performAction = (value) => {
        const isValEmpty = !_.isEmpty(value);
        setValue(value);
        if(isValEmpty) {
            setKeyCount(keyCount + 1);
            console.log(keyCount);
        }
    };

    return(
        <Box input={input} >
            <PasswordEntry
                name={name}
                input={input}
                meta={meta}
                placeholder={placeholder}
                performAction={ performAction } />

            <Box sx={{marginTop: '15px'}}>
                <PasswordStrengthIndicator
                    input={input}
                    value={value}
                    isVisible={ keyCount > 0 }
                    passwordStrength={passwordStrength(value)}
                    meta={meta} />
            </Box>
        </Box>
    )
}